import { Record } from 'immutable';
import { handleActions } from 'redux-actions';
import { SET_SESSION_STATUS, RESET_AUTH_ERROR, SKIP_LOGIN_STEP } from '../actions/auth';
import {
  USER_AUTHENTICATE_LOAD_REQUESTED,
  USER_AUTHENTICATE_LOAD_SUCCEEDED,
  USER_AUTHENTICATE_LOAD_FAILED,
} from '../actions/userInfo';

export const ReducerRecord = Record({
  authenticated: false,
  sessionStatus: false,
  error: null,
  fetching: false,
  isLoginSkipped: false,
});

export default handleActions({
  [USER_AUTHENTICATE_LOAD_REQUESTED](state) {
    return state.set('fetching', true);
  },
  [USER_AUTHENTICATE_LOAD_SUCCEEDED](state) {
    return state.set('fetching', false);
  },
  [RESET_AUTH_ERROR](state) {
    return state.set('error', null);
  },
  [SET_SESSION_STATUS](state, { payload }) {
    return state.set('sessionStatus', payload);
  },
  [USER_AUTHENTICATE_LOAD_FAILED](state, { payload }) {
    return state
      .set('sessionStatus', false)
      .set('error', payload)
      .set('fetching', false);
  },
  [SKIP_LOGIN_STEP](state) {
    return state.set('isLoginSkipped', true);
  },
}, new ReducerRecord());
